import createClient from 'openapi-fetch';

import { stepinMiddleware } from '@/@shared/middleware/middleware';

import { type components, type paths } from '@/legacy/apis/spec/authType';

// export const stepinAuthInstance = createClient<paths>({ baseUrl: process.env.NEXT_PUBLIC_STEPIN_AUTH });
// stepinAuthInstance.use(stepinMiddleware);

const instanceGetter = () => {
	const stepinAuthInstance = createClient<paths>({ baseUrl: process.env.NEXT_PUBLIC_STEPIN_AUTH });
	stepinAuthInstance.use(stepinMiddleware);
	return stepinAuthInstance;
};

export const stepinAuthInstance = instanceGetter();

// internal 은 서버용
// web 은 web용 > 같은 경로인데 Web이 붙은 게 있으면 web으로 써야함 > ex) signin
export type SignupEmailBody = components['schemas']['SignupEmailBody'];
export type SignupEmailRO = components['schemas']['SignupEmailRO'];

export type SignupOauthBody = components['schemas']['SignupOauthBody'];
export type SignupOauthRO = components['schemas']['SignupOauthRO'];
export type SigninEmailBody = components['schemas']['SigninEmailBody'];
export type SigninUser = components['schemas']['SigninUser'];
export type SigninEmailRO = components['schemas']['SigninEmailRO'];
export type SigninOauthBody = components['schemas']['SigninOauthBody'];
export type SigninOauthRO = components['schemas']['SigninOauthRO'];
export type SwitchBusinessAccountBody = components['schemas']['CheckBusinessLinkedBody'];
export type SwitchBusinessAccountRO = components['schemas']['CheckBusinessLinkedRO'];
export type GrantBusinessAccountOwnerBody = components['schemas']['GrantBusinessAccountOwnerBody'];
export type GrantBusinessAccountAdminBody = components['schemas']['GrantBusinessAccountAdminBody'];
export type SimpleUserInfo = components['schemas']['SimpleUserInfo'];
export type GetBusinessAccountMemberRO = components['schemas']['GetBusinessAccountMemberRO'];
export type GetBusinessAuthorityRO = components['schemas']['GetBusinessAuthorityRO'];
export type ValidateTokenBody = components['schemas']['ValidateTokenBody'];
export type ValidateTokenRO = components['schemas']['ValidateTokenRO'];
export type RefreshTokenBody = components['schemas']['RefreshTokenBody'];
export type RefreshTokenRO = components['schemas']['RefreshTokenRO'];
export type SendEmailBody = components['schemas']['SendEmailBody'];
export type SendEmailRO = components['schemas']['SendEmailRO'];
export type VerifyEmailBody = components['schemas']['VerifyEmailBody'];
export type VerifyEmailRO = components['schemas']['VerifyEmailRO'];
export type ResetPasswordBody = components['schemas']['ResetPasswordBody'];
export type ResetPasswordRO = components['schemas']['ResetPasswordRO'];
export type MakeBusinessAccountBody = components['schemas']['MakeBusinessAccountBody'];
export type ValidateUserPasswordBody = components['schemas']['ValidateUserPasswordBody'];
export type ValidateUserPasswordRO = components['schemas']['ValidateUserPasswordRO'];
export type ChangeUserPasswordBody = components['schemas']['ChangeUserPasswordBody'];
export type VerifyUserBody = components['schemas']['VerifyUserBody'];
export type GetUserNationRO = components['schemas']['GetUserNationRO'];
export type GetUserInfoRO = components['schemas']['GetUserInfoRO'];
export type AllowTermsBody = components['schemas']['AllowTermsBody'];
export type LinkedBusinessAccount_User = components['schemas']['LinkedBusinessAccount_User'];
export type LinkedBusinessAccount_Business = components['schemas']['LinkedBusinessAccount_Business'];
export type LinkedBusinessAccount = components['schemas']['LinkedBusinessAccount'];
export type GetLinkedBusinessAccountListRO = components['schemas']['GetLinkedBusinessAccountListRO'];
export type CheckBusinessAccountRO = components['schemas']['CheckBusinessAccountRO'];
